(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const running = new Map();
  let queued = false;
  function focusCard(card, editing) {
    card.querySelector(editing ? '.jcm-editor-close' : '.jcm-engraving-toggle')?.focus({ preventScroll: true });
  }
  function measure() {
    queued = false;
    const root = document.querySelector('#cartAppA .jcr-cart');
    if (!root) { states.clear(); return; }
    const cards = Array.from(root.querySelectorAll('[data-engraving-item]'));
    const present = new Set(cards.map(card => card.getAttribute('data-engraving-item')));
    cards.forEach(card => {
      const key = card.getAttribute('data-engraving-item');
      const variant = card.getAttribute('data-engraving-variant');
      const editing = card.classList.contains('jcm-engraving-editing');
      const previous = states.get(key) || Array.from(states.values()).find(state => state.editing && state.variant === variant && !present.has(state.key));
      if (running.has(key) && previous?.editing === editing) return;
      running.get(key)?.cancel();
      running.delete(key);
      const height = card.getBoundingClientRect().height;
      states.set(key, { key, variant, editing, height });
      if (!mobile.matches || !previous || previous.editing === editing) return;
      if (reduced.matches) { focusCard(card, editing); return; }
      card.classList.add('jcm-engraving-animating');
      const animation = card.animate([
        { height: previous.height + 'px' },
        { height: height + 'px' }
      ], { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)' });
      running.set(key, animation);
      const content = card.querySelector(editing ? '.jcc-engraving' : '.jcr-item-main');
      content?.animate([
        { opacity: 0, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 300, easing: 'cubic-bezier(.22,1,.36,1)' });
      const finish = () => {
        if (running.get(key) !== animation) return;
        running.delete(key);
        card.classList.remove('jcm-engraving-animating');
        states.set(key, { key, variant, editing, height: card.getBoundingClientRect().height });
        focusCard(card, editing);
      };
      animation.onfinish = finish;
      animation.oncancel = finish;
    });
    for (const key of states.keys()) if (!present.has(key)) { running.get(key)?.cancel(); running.delete(key); states.delete(key); }
  }
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(measure); } };
  const start = () => {
    const app = document.getElementById('cartAppA');
    if (!app) return;
    const observer = new MutationObserver(schedule);
    observer.observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    app.addEventListener('load', schedule, true);
    app.addEventListener('keydown', event => {
      if (!mobile.matches || event.key !== 'Escape') return;
      const close = app.querySelector('.jcm-engraving-editing .jcm-editor-close');
      if (!close) return;
      event.preventDefault();
      event.stopPropagation();
      if (!close.disabled) close.click();
    });
    mobile.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    measure();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
